@if (column.label) {
  <div class="column-label">
    {{ column.label.translate ? (column.label.title | cxTranslate) : column.label.title }}
  </div>
}
